import React from 'react'
import NextLink from 'next/link'

import { Breadcrumb, BreadcrumbItem } from '@wartek-id/breadcrumb'

import styles from './DocumentBreadcrumb.module.css'

export type BreadcrumbItemDef = {
  label: string
  href: string | null
}

interface IDocumentBreadcrumbProps {
  items: BreadcrumbItemDef[]
  className?: string
}

const DocumentBreadcrumb = ({ items, className }: IDocumentBreadcrumbProps) => (
  <div className={`${styles.breadcrumb}${className ? ` ${className}` : ''}`}>
    <Breadcrumb>
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        return (
          <BreadcrumbItem key={index} isCurrentPage={isLast}>
            {!isLast && item.href ? (
              <NextLink href={item.href}>
                <a className={styles.label}>{item.label}</a>
              </NextLink>
            ) : (
              <span className={styles.label}>{item.label}</span>
            )}
          </BreadcrumbItem>
        )
      })}
    </Breadcrumb>
  </div>
)

export default DocumentBreadcrumb
